export function useFitterAPI() {
  const { errors, request } = useRequest();

  async function getFitters() {
    const url = versionedUrl('Fitter/GetFitters');
    const response = await request<FitterResponseDTO[]>(url, {
      method: 'GET'
    });

    return response;
  }

  return {
    errors,
    getFitters
  };
}
